/**
 * Returns an array of the own enumerable string-keyed property [key, value] pairs of the given object,
 * with proper TypeScript typing of keys as keyof T and values as T[key].
 *
 * This function preserves type safety compared to Object.entries, allowing for better type inference
 * when iterating object entries.
 *
 * @example
 *   const obj = { a: 1, b: 2 };
 *   const entries = ObjectEntries(obj); // [ ['a', 1], ['b', 2] ]
 *
 * @param obj - The object whose enumerable own string-keyed property [key, value] pairs are to be returned.
 * @returns Array of [key, value] pairs with correct types.
 */
export const ObjectEntries = <T extends object>(obj: T): Array<[keyof T, T[keyof T]]> => {
	return Object.entries(obj).map(
		([key, value]) => [key as keyof T, value as T[keyof T]],
	);
};
